export enum PlayerContentType {
    FILM = 'film',
    SEASON = 'season',
    EPISODE = 'episode',
    TRAILER = 'trailer',
    CHANNEL = 'channel',
    SPORT_LIVE = 'sport-live',
    UNKNOWN = 'unknown',
}
